// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__12U2K","buttonDefault":"styles_buttonDefault__Emy-2","buttonSubmit":"styles_buttonSubmit__1le7b","buttonCancel":"styles_buttonCancel__LWXHl"};